import Typography from "@mui/material/Typography";
import type { SearchTemplateValue } from "../../api/";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { setClassNamesByCount } from "./utils";

export const ExpiredRemindersProspect = ({
	expiredRemindersProspect,
	readOnly = false,
}: {
	expiredRemindersProspect: SearchTemplateValue;
	readOnly?: boolean;
}) => {
	return (
		<BaseTodoBox
			className={setClassNamesByCount(expiredRemindersProspect.count)}
			title={
				<AttentionBadge
					count={expiredRemindersProspect.count}
					title="Expired Prospect Reminders"
					readOnly={readOnly}
					url={expiredRemindersProspect.url}
				/>
			}
			description={
				<>
					<Typography variant="body1" color="textPrimary">
						Remove or postpone reminder
					</Typography>
				</>
			}
		/>
	);
};
